import { createI18n, type I18nOptions } from 'vue-i18n';

const locales = require.context('./locales', false, /\.json$/);

const messages = locales.keys().reduce(
  (acc: Record<string, Record<string, unknown>>, key: string) => {
    const locale = key.replace('./', '').replace('.json', '');
    acc[locale] = locales(key) as Record<string, unknown>;
    return acc;
  },
  {},
);

const availableLocales = Object.keys(messages);

const resolveLocale = () => {
  if (typeof navigator === 'undefined') {
    return 'en';
  }

  const navLangs = navigator.languages || [];
  const preferred = [...navLangs, navigator.language].filter(Boolean) as string[];

  const match = preferred.find((locale) => {
    const normalized = locale.toLowerCase();
    const exact = availableLocales.find(
      (available) => available.toLowerCase() === normalized,
    );
    if (exact) {
      return true;
    }

    const base = normalized.split('-')[0];
    return availableLocales.some((available) => available.toLowerCase() === base);
  });

  if (match) {
    const normalized = match.toLowerCase();
    const exact = availableLocales.find(
      (available) => available.toLowerCase() === normalized,
    );
    if (exact) {
      return exact;
    }

    const base = normalized.split('-')[0];
    const baseMatch = availableLocales.find((available) => available.toLowerCase() === base);
    return baseMatch || 'en';
  }

  return 'en';
};

const i18n = createI18n({
  legacy: true,
  globalInjection: true,
  locale: resolveLocale(),
  fallbackLocale: 'en',
  messages,
} as I18nOptions);

export default i18n;
export { availableLocales };
